import { render, staticRenderFns } from "./CoachProfileCard.vue?vue&type=template&id=6eb668c0&scoped=true&"
import script from "./CoachProfileCard.vue?vue&type=script&lang=ts&"
export * from "./CoachProfileCard.vue?vue&type=script&lang=ts&"
import style0 from "./CoachProfileCard.vue?vue&type=style&index=0&id=6eb668c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb668c0",
  null
  
)

export default component.exports